import {useEffect, useMemo, useState} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import {normalizeProductName} from "../helpers/utils";

export default function ReturnProductsPage() {
    const today = new Date();
    const startD = new Date(today);
    startD.setDate(today.getDate() - 13); // 14 дней включая сегодня
    startD.setHours(0, 0, 0, 0);

    const endD = new Date(today);
    endD.setHours(23, 59, 59, 999);

    const [from, setFrom] = useState(startD);
    const [to, setTo] = useState(endD);

    const [products, setProducts] = useState([]);
    const [sortKey, setSortKey] = useState("quantity");
    const [sortDirection, setSortDirection] = useState("desc");
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        fetchData();
    }, []);

    const sortedProducts = useMemo(() => {
        const sorted = [...products].sort((a, b) => {
            const aVal = a[sortKey];
            const bVal = b[sortKey];

            // сортировка по числу
            if (sortKey === "quantity") {
                return sortDirection === "asc"
                    ? aVal - bVal
                    : bVal - aVal;
            }

            if (["soldQty", "returnedQty", "percentReturned", "shareOfReturns"].includes(sortKey)) {
                return sortDirection === "asc" ? aVal - bVal : bVal - aVal;
            }


            // сортировка по строке (например, name, color)
            const aStr = aVal?.toString().toLowerCase();
            const bStr = bVal?.toString().toLowerCase();

            if (aStr < bStr) return sortDirection === "asc" ? -1 : 1;
            if (aStr > bStr) return sortDirection === "asc" ? 1 : -1;
            return 0;
        });

        return sorted;
    }, [products, sortKey, sortDirection]);


    const handleSort = (key) => {
        if (sortKey === key) {
            setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDirection("asc");
        }
    };
    const setCurrentMonth = () => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        setFrom(start);
        setTo(end);
    };

    const setPreviousMonth = () => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const end = new Date(now.getFullYear(), now.getMonth(), 0);
        setFrom(start);
        setTo(end);
    };

    useEffect(() => {
        fetchData();
    }, [from, to]);



    const totalSoldQty = useMemo(() =>
        products.reduce((sum, p) => sum + (p.soldQty || 0), 0), [products]);

    const totalReturnedQty = useMemo(() =>
            products.reduce((sum, p) => sum + (p.returnedQty || 0), 0),
        [products]
    );



    const limit = "limit=50"
    const sort = "sort=id"
    const start = new Date(from.setHours(0, 0, 0, 0)).toISOString();
    const end = new Date(to.setHours(23, 59, 59, 999)).toISOString();
    const filter = encodeURIComponent("filter[created_between]") + "=" + encodeURIComponent(start + ", " + end)
    const includes = "include=" + encodeURIComponent("manager, tags, products.offer")
    //const statuses = encodeURIComponent("filter[status_id]") + "=" + encodeURIComponent("20,21,39");

    const parameters = [limit, sort, filter, includes].join("&")

    function groupByProductAndColor(orders) {
        const excludeSoldStatuses = [24, 35, 36, 40, 41, 19, 37, 38];
        const returnStatuses = [20, 21, 39];

        const isReturnStatus = (status_id) => returnStatuses.includes(status_id);
        const isExcludedFromSold = (status_id) => excludeSoldStatuses.includes(status_id);

        const grouped = {};
        const unusualColorProps = new Set();

        const normalize = (str) =>
            (str || "").toLowerCase().trim().replace(/i/g, "і");

        for (const order of orders) {
            const hasBarterTag = order.tags?.some(tag => tag.id === 1);
            const hasWholesaleTag = order.tags?.some(tag => tag.id === 4);

            if (hasBarterTag || hasWholesaleTag) {
                continue; // Пропускаем бартер и опт
            }
            const returned = isReturnStatus(order.status_id);
            const excluded = isExcludedFromSold(order.status_id);


            for (const product of order.products || []) {
                const productId = product.offer?.product_id;
                if (!productId) continue;

                const props = product.offer?.properties || [];

                let rawColor = "Невідомий";

                for (const p of props) {
                    const name = normalize(p.name);
                    if (name === "колір") {
                        rawColor = p.value;
                        break;
                    } else {
                        unusualColorProps.add(`${p.name} (товар: ${product.name})`);
                    }
                }

                const color = normalize(rawColor);
                let nameRaw = product.name || "";

                // 👇 Спец. перейменування за ID
                if (productId === 228) {
                    nameRaw = "Блуза піжамна з трикотажу";
                } else if (productId === 230) {
                    nameRaw = "Шорти піжамні з трикотажу";
                }

                let baseName = normalizeProductName(nameRaw);

                if (productId === 72) {
                    baseName = "Купальник квадрат";
                } else if (productId === 73) {
                    baseName = "Купальник на зав'язках";
                }

                const key = `${productId}__${color}__${baseName}`;
                console.log("KEY:", key, "ID:", productId, "Name:", baseName, "Color:", color);


                if (!grouped[key]) {
                    grouped[key] = {
                        product_id: productId,
                        name: baseName,
                        color,
                        soldQty: 0,
                        returnedQty: 0
                    };
                }

                if (!excluded) {
                    grouped[key].soldQty += product.quantity || 1;
                }

                if (returned) {
                    grouped[key].returnedQty += product.quantity || 1;
                }

                grouped[key].percentReturned =
                    grouped[key].soldQty > 0
                        ? (grouped[key].returnedQty / grouped[key].soldQty) * 100
                        : 0;
            }
        }

        if (unusualColorProps.size > 0) {
            console.warn("⚠️ Незвичні назви властивості кольору, перевір:", [...unusualColorProps]);
        }
        const groupedArray = Object.values(grouped);

        const totalReturned = groupedArray.reduce((sum, p) => sum + (p.returnedQty || 0), 0);

        for (const item of groupedArray) {
            item.shareOfReturns = totalReturned > 0
                ? (item.returnedQty / totalReturned) * 100
                : 0;
        }

        return groupedArray;
    }


    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`/api/returns-report?${parameters}`);
            const grouped = groupByProductAndColor(res.data);
            setProducts(grouped);
        } catch (error) {
            console.error("Помилка завантаження:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4 flex items-center gap-2">
                Товари з повернень
                <span
                    title="Тут відображаються товари, продані за вибраний період, та кількість повернутих речей. При підрахунку проданих товарів виключено замовлення з червоної групи статусів ('Заміна', 'Скасовано', 'Внутр скасування'), 2-ї групи статусів, а також опт і бартери. У підрахунку повернень враховуються лише замовлення зі статусами 'Повернення', 'Відміна', 'Част повернення'."
                    className="text-blue-500 cursor-help text-sm px-2" style={{ zoom: "0.7" }}
                >
                ℹ️
              </span>
            </h2>
            <div className="flex gap-4 mb-4">
                <div className="flex gap-2 mb-4">
                    <button
                        onClick={setCurrentMonth}
                        className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300 transition"
                    >
                        Поточний місяць
                    </button>

                    <button
                        onClick={setPreviousMonth}
                        className="bg-gray-200 px-3 py-1 rounded hover:bg-gray-300 transition"
                    >
                        Минулий місяць
                    </button>
                </div>
                <div className="flex flex-wrap items-end gap-4 mb-4">
                    <label className="flex flex-col text-sm text-gray-500">
                        <DatePicker
                            selected={from}
                            onChange={(date) => setFrom(date)}
                            locale="uk"
                            dateFormat="yyyy-MM-dd"
                            calendarStartDay={1}
                            selectsStart
                            startDate={from}
                            endDate={to}
                            className="border px-2 py-1 rounded min-w-[140px]"
                        />
                    </label>
                    <label className="flex flex-col text-sm text-gray-500">
                        <DatePicker
                            selected={to}
                            onChange={(date) => setTo(date)}
                            locale="uk"
                            dateFormat="yyyy-MM-dd"
                            calendarStartDay={1}
                            selectsEnd
                            startDate={from}
                            endDate={to}
                            minDate={from}
                            className="border px-2 py-1 rounded min-w-[140px]"
                        />
                    </label>

                    {loading ? (
                        <span className="d-inline-block h-[38px] mt-3 mt-lg-0 px-lg-3 text-blue-600">
                            Завантаження...
                        </span>
                    ) : (
                        <button
                            onClick={fetchData}
                            className="bg-blue-600 text-white mt-3 mt-lg-0 px-4 py-2 rounded h-[38px]"
                        >
                            Завантажити
                        </button>
                    )}

                </div>
            </div>
            {!loading && products.length > 0 && (
            <table className="w-full border">
                <thead>
                <tr className="bg-gray-100 cursor-pointer select-none">
                    <th className="p-2 border" onClick={() => handleSort("name")}>
                        Назва {sortKey === "name" && (sortDirection === "asc" ? "▲" : "▼")}
                    </th>
                    <th className="p-2 border" onClick={() => handleSort("color")}>
                        Колір {sortKey === "color" && (sortDirection === "asc" ? "▲" : "▼")}
                    </th>
                    <th className="p-2 border text-right" onClick={() => handleSort("soldQty")}>
                        Кількість продано {sortKey === "soldQty" && (sortDirection === "asc" ? "▲" : "▼")}
                    </th>
                    <th className="p-2 border text-right" onClick={() => handleSort("returnedQty")}>
                        Кількість повернуто {sortKey === "returnedQty" && (sortDirection === "asc" ? "▲" : "▼")}
                    </th>
                    <th className="p-2 border text-right" title="Відсоток повернення цього товару відносно проданих одиниць цього товару" onClick={() => handleSort("percentReturned")}>
                        Повернення товару, % {sortKey === "percentReturned" && (sortDirection === "asc" ? "▲" : "▼")}
                    </th>
                    <th
                        className="p-2 border text-right cursor-pointer"
                        onClick={() => handleSort("shareOfReturns")}
                        title="Частка цієї позиції серед усіх повернень за вибраний період"
                    >
                        Частка у поверненнях, %
                        {sortKey === "shareOfReturns" && (sortDirection === "asc" ? "▲" : "▼")}
                    </th>
                </tr>
                </thead>
                <tbody>
                {sortedProducts.map((p, i) => {
                    return (
                        <tr key={i}>
                            <td className="p-2 border">{p.name}</td>
                            <td className="p-2 border">{p.color}</td>
                            <td className="p-2 border text-right">{p.soldQty}</td>
                            <td className="p-2 border text-right">{p.returnedQty}</td>
                            <td className="p-2 border text-right">
                                {p.percentReturned.toFixed(1)}%
                            </td>
                            <td className="p-2 border text-right">
                                {p.shareOfReturns.toFixed(1)}%
                            </td>
                        </tr>
                    );
                })}
                </tbody>
                <tfoot>
                <tr className="bg-gray-50 font-semibold">
                    <td className="p-2 border text-right" colSpan={2}>Всього:</td>
                    <td className="p-2 border text-right">{totalSoldQty}</td>
                    <td className="p-2 border text-right">{totalReturnedQty}</td>
                    <td className="p-2 border">{((totalReturnedQty / totalSoldQty) * 100).toFixed(1)}%</td>
                </tr>
                </tfoot>
            </table>)}
        </div>
    );
}
